module.exports = __webpack_public_path__ + "static/img/productCock-overlay-works2-m1.63bb59f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productCock-overlay-works2-m1.png
// module id = 196
// module chunks = 0